(function () {
    'use strict';

    angular
        .module('backApp')
        .factory('Process', Process);

    Process.$inject = ['$resource'];

    function Process($resource) {
        var resourceUrl = 'manager/api/process-operations/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                params: {
                    // path: '',
                    origin: 'STORE'
                }
            },
            'get': {
                method: 'GET',
                params: {
                    path: ''
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                params: {
                    path: ''
                }
            },
            'save': {
                method: 'POST',
                params: {
                    path: ''
                }
            }
        });
    }
})();
